"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutSectionFacade = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var item_1 = require("./item");
var items_1 = require("./items");
/**
 * @alpha
 */
var DashboardLayoutSectionFacade = /** @class */ (function () {
    function DashboardLayoutSectionFacade(layoutFacade, section, sectionIndex) {
        this.layoutFacade = layoutFacade;
        this.section = section;
        this.sectionIndex = sectionIndex;
    }
    DashboardLayoutSectionFacade.for = function (layoutFacade, section, index) {
        return new DashboardLayoutSectionFacade(layoutFacade, section, index);
    };
    DashboardLayoutSectionFacade.prototype.raw = function () {
        return this.section;
    };
    DashboardLayoutSectionFacade.prototype.header = function () {
        return this.section.header;
    };
    DashboardLayoutSectionFacade.prototype.title = function () {
        var _a;
        return (_a = this.header()) === null || _a === void 0 ? void 0 : _a.title;
    };
    DashboardLayoutSectionFacade.prototype.description = function () {
        var _a;
        return (_a = this.header()) === null || _a === void 0 ? void 0 : _a.description;
    };
    DashboardLayoutSectionFacade.prototype.index = function () {
        return this.sectionIndex;
    };
    DashboardLayoutSectionFacade.prototype.isFirst = function () {
        return this.indexIs(0);
    };
    DashboardLayoutSectionFacade.prototype.isLast = function () {
        return this.indexIs(this.layoutFacade.sections().count() - 1);
    };
    DashboardLayoutSectionFacade.prototype.testRaw = function (pred) {
        return pred(this.raw());
    };
    DashboardLayoutSectionFacade.prototype.test = function (pred) {
        return pred(this);
    };
    DashboardLayoutSectionFacade.prototype.indexIs = function (index) {
        return this.index() === index;
    };
    DashboardLayoutSectionFacade.prototype.headerEquals = function (header) {
        return isEqual_1.default(this.header(), header);
    };
    DashboardLayoutSectionFacade.prototype.hasHeader = function () {
        return !isNil_1.default(this.header());
    };
    DashboardLayoutSectionFacade.prototype.hasTitle = function () {
        return !isNil_1.default(this.title());
    };
    DashboardLayoutSectionFacade.prototype.hasDescription = function () {
        return !isNil_1.default(this.description());
    };
    DashboardLayoutSectionFacade.prototype.titleEquals = function (title) {
        return isEqual_1.default(this.title(), title);
    };
    DashboardLayoutSectionFacade.prototype.descriptionEquals = function (description) {
        return isEqual_1.default(this.description(), description);
    };
    DashboardLayoutSectionFacade.prototype.isEmpty = function () {
        return this.items().count() === 0;
    };
    DashboardLayoutSectionFacade.prototype.items = function () {
        return items_1.DashboardLayoutItemsFacade.for(this, this.section.items);
    };
    DashboardLayoutSectionFacade.prototype.item = function (index) {
        var column = this.section.items[index];
        if (!column) {
            return undefined;
        }
        return item_1.DashboardLayoutItemFacade.for(this, column, index);
    };
    DashboardLayoutSectionFacade.prototype.layout = function () {
        return this.layoutFacade;
    };
    return DashboardLayoutSectionFacade;
}());
exports.DashboardLayoutSectionFacade = DashboardLayoutSectionFacade;
//# sourceMappingURL=section.js.map